module.exports = __webpack_public_path__ + "img/Oryza_sativa.76a4e65b.jpg";